import { useState } from 'react';

export function useModal<T>() {
  const [isOpen, setIsOpen] = useState(false);
  const [item, setItem]     = useState<T | null>(null);

  const open  = (data: T) => { setItem(data); setIsOpen(true); };
  const close = ()        => { setIsOpen(false); };

  return { isOpen, item, open, close };
}
